<template>
    <FormModal :model="model" :init="init" modal-id="listing_html">
        <template>
            <div :key="key" class="d-flex">
                <b-badge
                    :variant="$store.getters['user/level2variant'](model.level)"
                    class="align-self-center mr-1"
                    >
                    {{
                    trans.labels[
                    'users.level.' + model.level
                    ]
                    }}
                </b-badge>
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <b-form-checkbox
                    v-model="model.is_default"
                    :value="1"
                    :unchecked-value="0"
                    >
                    初期値として利用する
                </b-form-checkbox>
                <input-error :errors="error.is_default" />

                <b-form-group
                    label-cols-sm="2"
                    label="保存名"
                    label-size="sm"
                    @submit.stop.prevent
                    >
                    <b-form-input
                        v-model="model.name"
                        size="sm"
                        ></b-form-input>
                    <input-error :errors="error.name" />
                </b-form-group>

                <HtmlEditorWzPreview v-model="model.html" />
                <input-error :errors="error.html" />
            </template>
            <template v-else>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import InputError from '@/components/InputError.vue'
import HtmlEditorWzPreview from '@/components/HtmlEditorWzPreview.vue'

export default {
    components: {
        FormModal,
        InputError,
        HtmlEditorWzPreview,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'trans',
        ])
    },
    mounted() {},
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>


